module.exports = "/_next/static/images/Protocols@2x-2d32170473ba3b7603d804c8a757c46e.webp";